/**
 * CONFIGURACIÓN DE LA LANDING /resources/ai-commercial-system (lead magnet del sistema
 * comercial con IA: seguimiento de leads antes de la venta y de clientes después).
 *
 * Misma regla que el kit (`lib/aiKit.js`): lo que no está confirmado va VACÍO y la página
 * tiene un camino honesto para cada hueco.
 */

export const AI_COMMERCIAL_PATH = '/resources/ai-commercial-system';

/** URL pública de la landing: es la que lleva el QR del dossier. */
export const AI_COMMERCIAL_URL = 'https://invokeapp.io/resources/ai-commercial-system';

/**
 * Integración de lead magnet (lead-magnet-crm-email) que atiende esta landing: crea el lead,
 * devuelve el contenido en pantalla y encola el correo. El CONTENIDO se configura en esa
 * integración, dentro de la plataforma (plantilla: E:\InvokeApp\AI-Commercial-System\).
 * Ojo: el core guarda la plantilla por EMPRESA (no por integración): si esta integración es de
 * la misma empresa que la del kit de IA, las dos landings entregan el mismo correo.
 */
export const AI_COMMERCIAL_PROV_ID = 'prov_l5FqWO4t2tlhK2VKPs1-bw';

/** Origen que se graba en el lead (SourceLeads). */
export const AI_COMMERCIAL_SOURCE = 'ai_commercial_system';

/** Vista previa REAL del recurso (imagen en public/assets/...). Vacío = sin imagen. */
export const aiCommercialVisuals = {
  resourcePreview: '',
};
